import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconSavingAccountPromotion } from '../../../../assets/dashboard/saving-account-promotion-icon.svg';
import { ProfilePlanPromotion } from '../../../../flows/profile/components/ProfilePlanPromotion';
import { SimpleWidgetSkeleton } from '../../components/skeletons/SimpleWidgetSkeleton';

export const SavingsPromotionWidget = ({ isLoading }: { isLoading: boolean }) => {
  const { t } = useTranslation();
  if (isLoading) return (<SimpleWidgetSkeleton />);
  return (
    <div className='flex items-center flex-wrap flex-col px-[18px] py-[16px]'>
      <IconSavingAccountPromotion />
      <div className='font-metricR text-bw08 text-sm py-[12px]' data-testid='SavingPromotionWidget_title'>
        {t('WIDGET_SAVINGS_PROMOTION.TITLE')}
        <span className='mx-[3px] font-metricRSemibold'>{t('APY_PERCENT')}</span>
        {t('APY')}
      </div>
      <ProfilePlanPromotion
        customTitle={t('WIDGET_SAVINGS_PROMOTION.BUTTON')}
        planType='BASIC_V2'
        shouldAppearAsButton
        testId='SavingPromotionWidget_button'
        buttonClassName='w-[150px] h-[40px] rounded-[4px] flex items-center mx-auto justify-center self-center border-[1px] border-bw05 font-metricRSemibold text-sm text-action03 hover:text-action04'
      />
    </div>
  );
};
